import { flattenDeep, filter } from 'lodash';
import buildOptions from "./buildOptions";
import isMultiLevel from "./isMultiLevel";
function countOptions(options) {
  let availableOptions = [];
  if (isMultiLevel(options)) {
    availableOptions = buildOptions({
      options,
      selected: [],
      removeDisabled: true
    });
    return filter(flattenDeep(availableOptions), o => !o.hasChildren).length;
  }
  return filter(options, o => !o.selectionDisabled).length;
}
export default countOptions;
//# sourceMappingURL=countOptions.js.map